import { useLanguage } from './LanguageContext';
import { t as translate } from './translations';

export const useTranslation = () => {
  const { language } = useLanguage();
  
  return {
    language,
    t: (key) => translate(key, language),
  };
};
